var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManWithKite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 274,
    height: 650,
    viewBox: "0 0 274 650",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M194.1 554.047C194.1 554.047 199.9 551.947 202.5 561.347C203.5 565.047 203.7 567.847 204.5 572.447",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.139 269.047C101.617 344.521 103.527 387.161 119 425",
    stroke: "url(#paint0_linear_695_27614)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0388 252.247C61.8388 251.247 61.7388 250.147 61.7388 249.047C61.7388 237.447 72.0388 228.147 84.6388 228.147C90.5388 228.147 95.9388 230.147 100.039 233.547C104.039 227.547 111.339 223.547 119.539 223.547C130.539 223.547 139.639 230.547 141.939 239.947C146.039 236.547 151.439 234.447 157.439 234.447C170.139 234.447 180.339 243.847 180.339 255.347C180.339 266.947 170.039 276.247 157.439 276.247C155.739 276.247 154.139 276.047 152.539 275.747C149.739 284.447 140.939 290.847 130.539 290.847C127.439 290.847 124.539 290.247 121.839 289.247C116.839 295.147 108.939 299.047 100.139 299.047C89.3388 299.047 79.9388 293.347 75.5388 285.047C72.7388 286.447 69.6388 287.247 66.2388 287.247C55.5388 287.247 46.7388 279.247 46.7388 269.447C46.8388 261.147 53.3388 254.047 62.0388 252.247Z",
    fill: "white",
    stroke: "#B4B4B4",
    strokeWidth: 3.2831,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.439 256.746C104.439 256.746 125.5 95 24.5 113",
    stroke: "#020203",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3389 256.946C98.3389 256.946 106.139 255.246 110.539 259.646L98.3389 256.946Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3389 256.946C98.3389 256.946 106.139 255.246 110.539 259.646",
    stroke: "#B4B4B4",
    strokeWidth: 2.1544,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M129.939 262.246C129.939 262.246 135.039 248.646 150.939 257.246L129.939 262.246Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M129.939 262.246C129.939 262.246 135.039 248.646 150.939 257.246",
    stroke: "#B4B4B4",
    strokeWidth: 2.1544,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M7.91382 110.697L46.9637 148.646L60.1636 95.8467L7.91382 110.697Z",
    fill: "#26B0A3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_695_27614)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M165.724 637.199C196.841 637.199 222.067 633.809 222.067 629.626C222.067 625.443 196.841 622.053 165.724 622.053C134.606 622.053 109.381 625.443 109.381 629.626C109.381 633.809 134.606 637.199 165.724 637.199Z",
    fill: "#CAC9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.833 487.567C144.833 487.567 130.072 500.004 126.109 518.592C122.145 537.18 125.562 563.831 125.562 563.831L212.35 577.908C212.35 577.908 223.147 537.18 219.457 522.145C215.766 507.111 203.876 495.631 197.862 491.257C191.848 486.884 144.833 487.567 144.833 487.567Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.296 557.679L131.439 617.952H201.279L212.35 557.679H128.296Z",
    fill: "#020203"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.156 495.768C207.156 495.768 243.101 519.139 233.944 545.107C227.657 563.011 205.243 564.651 205.243 564.651L198.546 554.811V508.615L207.156 495.768Z",
    fill: "#020203"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.694 618.227L164.787 577.771",
    stroke: "white",
    strokeWidth: 1.78837,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.578 458.865L166.837 465.699",
    stroke: "white",
    strokeWidth: 1.00031,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.432 616.176L190.208 626.973L181.325 627.93H171.621C171.621 627.93 168.341 622.463 172.851 620.003C172.851 620.003 176.131 618.089 179.958 619.183L179.548 616.176H187.612",
    fill: "#020203"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.587 614.672V626.152L140.323 626.972L130.345 626.016C130.345 626.016 128.295 621.095 131.986 620.002C135.676 618.909 138.546 619.592 138.546 619.592C138.546 619.592 143.193 619.319 143.193 614.672C143.193 610.025 156.587 614.672 156.587 614.672Z",
    fill: "#020203"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.826 570.527C201.826 570.527 191.439 561.507 192.259 552.896",
    stroke: "white",
    strokeWidth: 0.66683,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "1.33 1.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.899 543.33C133.899 543.33 130.755 556.724 122.828 560.141",
    stroke: "white",
    strokeWidth: 0.66683,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "1.33 1.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.359 552.485C199.912 550.572 201.142 554.126 203.192 558.089C205.242 562.053 206.746 563.283 203.192 565.196C199.639 567.11 198.955 564.923 196.222 561.369C194.309 558.636 192.805 554.399 196.359 552.485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.623 499.319C212.076 499.593 211.666 499.866 211.393 500.413C211.12 500.959 211.12 501.506 210.983 502.053C210.436 504.24 207.976 505.743 205.789 505.47",
    stroke: "black",
    strokeWidth: 1.33366,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M134.968 471.13C134.968 494.405 154.554 512.211 178.72 512.211C202.885 512.211 222.471 494.405 222.471 471.13C222.471 447.855 202.758 429.031 178.72 429.031C154.682 429.031 134.968 447.855 134.968 471.13Z",
    stroke: "#020203",
    strokeWidth: 2.92755,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.699 445.697C128.79 465.064 135.212 490.743 155.32 504.146C175.428 517.549 201.601 513.596 214.51 494.229C227.419 474.862 221.456 448.266 201.454 434.933C181.452 421.601 154.608 426.33 141.699 445.697Z",
    fill: "white",
    stroke: "#020203",
    strokeWidth: 2.92755,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.403 460.899C165.088 465.873 158.315 467.32 153.235 463.934C148.155 460.548 146.991 453.81 150.306 448.836C153.622 443.862 158.419 445.379 163.499 448.765C168.579 452.151 171.719 455.925 168.403 460.899Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.993 475.289C186.678 480.263 179.905 481.71 174.825 478.324C169.745 474.938 168.404 468.236 171.79 463.156C175.176 458.076 179.903 459.698 184.983 463.084C190.063 466.47 193.308 470.315 189.993 475.289Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.84 426.717C161.84 426.717 172.458 425.234 173.058 433.736C173.058 433.736 185.581 441.777 191.225 445.692C196.693 449.643 215.037 455.144 212.392 465.762C209.747 476.38 201.352 482.095 201.988 486.646C202.729 491.267 214.298 486.292 213.981 492.042C213.77 497.862 214.934 498.638 219.625 492.288C224.422 486.009 238.848 460.927 206.322 435.885C173.797 410.842 161.84 426.717 161.84 426.717Z",
    fill: "#4D3280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.835 443.228L210.523 483.013",
    stroke: "black",
    strokeWidth: 2.48228,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.889 449.929L150.659 452.893",
    stroke: "white",
    strokeWidth: 0.620538,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.04 455.501L158.068 457.83",
    stroke: "white",
    strokeWidth: 1.24108,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.561 464.778L173.589 467.107",
    stroke: "white",
    strokeWidth: 0.93087,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.867 479.707C155.867 479.707 157.087 483.285 160.749 485.725",
    stroke: "#020203",
    strokeWidth: 2.3182,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_695_27614",
    x1: 117.632,
    y1: 269.047,
    x2: 117.632,
    y2: 439.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#020203",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_695_27614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 174,
    height: 225,
    fill: "white",
    transform: "translate(79.5 418)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManWithKite);
export default __webpack_public_path__ + "static/media/man-with-kite.8773855bd9c88ebb0871bb693f430381.svg";
export { ForwardRef as ReactComponent };